import { Component, Inject } from '@angular/core';
import { Store } from '@src/store';
import { projectsActions } from '@src/store/reducers/projectsReducer';

@Component({
    selector: 'projects-menu-drop-down',
    template: require('./projects-menu-drop-down.component.html')
})
export class ProjectsMenuDropDownComponent {
    public projects: any[];

    private lastVisitedProjects: any[];
    public static $inject = ['store'];
    
    constructor(
        @Inject('$state') private $state: any,
        private store: Store,
        @Inject('projectsLocalHistoryService') private projectsLocalHistoryService: any) 
        {
            this.loadProjects();    
            this.store = store;
            projectsLocalHistoryService.registerObserverCallback(() => {
                this.loadProjects();
        });
    }

    private async loadProjects() {
        const projects = [];
        var exsitingProjects = await this.store.dispatch({ type: projectsActions.GET_PROJECTS });
        var exsitingProjects = this.store.getState().projects;

        const userId = this.$state.$current.locals.globals.userDetails.data.id;
        this.lastVisitedProjects = this.projectsLocalHistoryService.GetProjectsHistory(userId);
        if (this.lastVisitedProjects != null && this.lastVisitedProjects.length > 0) {
            const lastVisitedProjects = this.lastVisitedProjects.slice().reverse();
            const firstItem = lastVisitedProjects[0];
            lastVisitedProjects.forEach((item: any, k: any) => {
                //add to the last visited list only projects exists and are not drafts
                if (item && item.name && !item.isDraft && exsitingProjects.projectItems.filter(s=>s.id==item.id).length>0) {
                    if (k === 0) {
                        projects.push({
                            isDraft: item.isDraft,
                            name: item.name,
                            sref: 'app.authorized.environments',
                            params: { id: item.id, name: item.name }
                        });
                    } else {
                        if (firstItem === item.id) {
                            return;
                        }
                        projects.push({
                            isDraft: item.isDraft,
                            name: item.name,
                            sref: 'app.authorized.environments',
                            params: { id: item.id, name: item.name }
                        });
                    }
                }
            });
        }
        this.projects = projects.slice();
    }

    public navigate(event: any, item: any) {
        event.preventDefault();
        this.$state.go(item.sref, item.params);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/projects-menu-drop-down/projects-menu-drop-down.component.ts